var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryServiceRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 6.45898H5C3.27411 6.45898 1.875 7.85809 1.875 9.58398C1.875 11.3099 3.27411 12.709 5 12.709H8.33333",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2083 7.29102H15.8333C17.099 7.29102 18.125 8.31703 18.125 9.58268C18.125 10.8483 17.099 11.8743 15.8333 11.8743H15.2083",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9592 3.21982L8.33334 6.4591V12.7091L13.9593 15.9481C14.5148 16.2679 15.2083 15.8669 15.2083 15.2259V3.94199C15.2083 3.30093 14.5148 2.89994 13.9592 3.21982Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58334 13.5423V16.1465C9.58334 17.0094 8.88376 17.709 8.02084 17.709C7.1579 17.709 6.45834 17.0094 6.45834 16.1465V12.709",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryServiceRequest);
export default __webpack_public_path__ + "static/media/history_service_request.8f8a7869f5ed4ce6bcd26af63adeeb30.svg";
export { ForwardRef as ReactComponent };